module.exports = __webpack_public_path__ + "img/LogoDashboard-20.8500fb11.svg";